/**
 * Форматирует количество согласно следующим правилам:
 * - Максимальное количество символов: 2
 * - Слева от значения отображается +, если значение не максимальное.
 * - При достижении максимального + отображается справа от значения
 * - Если числовое значение превышает +9, то компонент отображает 9+
 */
export const formatCount = (count: number): string => {
    if (count <= 0) {
        return "0";
    }

    if (count > 9) {
        return "9+";
    }

    return `+${count}`;
};
